<!-- 首页地址搜索 -->
<template>
  <div class="commute_code">
    <div class="view-section">
      <!-- 搜索控件 -->
      <div class="view-search-control">
        <div class="control-title">
          <div class="title" @click.stop="switchSearchType">
            <div class="text">地点查询</div>
            <span class="line"></span>
          </div>
          <div class="title active">
            <div class="text">编号查询</div>
            <span class="line"></span>
          </div>
        </div>
        <div class="control-search">
          <div class="control-input">
            <input class="input" type="text" v-model="search_text" @focus="inputEve('focus')" @blur="inputEve('blur')" placeholder="请输入线路编号或名称" />
            <div class="wrap-icon" @click.stop="clearText" v-show="search_text">
              <span class="icon icon_gray_delete"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="view-btn-control">
        <div class="btn-opt-common" @click.stop="clickSearch">查询班车</div>
      </div>
    </div>
    <div class="wrap-view-list" :style="{'height': list_height + 'px'}" ref="commute_list" @scroll="listScroll">
      <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="all_search_loaded" :autoFill="false" ref="loadmore" >
        <div class="view-list">
          <template v-if="search_list.length >0" v-for="line in search_list">
            <div class="list-item" @click.stop="linkDetail(line)">
              <div class="item-top">
                <div class="title">{{ line.line_code || '--' }}</div>
                <div class="title title-right">{{ line.shift_name }}</div>
              </div>
              <div class="item-content">
                <div class="site">
                  <span class="line"></span>
                  <div class="wrap-dot">
                    <span class="icon-label icon_opt_up_site" style="float: left;
    position: relative;
    vertical-align: top;
    display: inline-block;
    padding: 0;
    margin: 0;"></span>
                    <!-- <span class="dot"></span> -->
                  </div>
                  <div class="content-text">{{ line.departure_station || '--' }}</div>
                  <div class="content-right content-label">
                    <!-- 下班 -->
                    <span class="opt_label_workoff" v-if="line.shuttle_type === '下班'"></span>
                    <!-- 上班 -->
                    <span class="opt_label_workon" v-if="line.shuttle_type === '上班'"></span>
                    <!-- 晚班 -->
                    <span class="opt_label_worklate" v-if="line.shuttle_type === '晚班'"></span>
                    <!-- 穿梭车 -->
                    <span class="opt_label_shutter" v-if="line.shuttle_type === '穿梭车'"></span>
                    <!-- 接驳车 -->
                    <span class="opt_label_feeder" v-if="line.shuttle_type === '接驳车'"></span>
                    <!-- 休息日订车 -->
                    <span class="opt_label_rester" v-if="line.shuttle_type === '预约休息日班线'"></span>
                    <!-- 今日未运营 -->
                    <span class="opt_label_off" v-if="line.operate_flag === 'N'"></span>
                  </div>
                </div>
                <div class="site end">
                  <div class="wrap-dot">
                    <span class="icon-label icon_opt_down_site" style="    float: left;
    position: relative;
    vertical-align: top;
    display: inline-block;
    padding: 0;
    margin: 0;"></span>
                    <!-- <span class="dot"></span> -->
                  </div>
                  <div class="content-text">{{ line.terminal || '--' }}</div>
                  <div class="content-right">
                    <span class="text">{{ line.line_price != '0.00' ? '￥' + line.line_price : '免费'}}</span>
                  </div>
                </div>
              </div>
              <div class="item-bottom">
                <div class="text" v-if="line.start_time">
                  <span class="text">始发站发车时间：</span>
                  <span class="text">{{line.start_time}}</span>
                </div>
                <div class="text" v-if="line.time_range">
                  <span class="text">发车时间段：</span>
                  <span class="text">{{line.time_range}}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="view-tips" :class="{'add-padding-bottom': is_fixed_bottom}" v-show="all_search_loaded && search_list.length > 0">
          <div class="text">暂无更多数据</div>
        </div>
        <div class="view-tips" v-show="all_search_loaded && search_list.length === 0">
          <div class="wrap-icon ">
            <span class="icon no_result"></span>
          </div>
          <div class="text">未搜索到相关班线</div>
        </div>
        <div class="view-search-logo" :class="{'view-fixed': is_fixed_bottom}" v-show="is_show_logo">
          <img src="../../src/assets/img/search_logo.png" alt="logo" class="icon">
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
import { Loadmore } from 'mint-ui'
import { mapGetters, mapActions } from 'vuex'
import { showTips, postCnzzData, formatDay } from '../assets/js/util'

export default {
  name: 'CommuteCode',
  components: {
    mtLoadmore: Loadmore
  },
  data () {
    return {
      search_text: '', // 搜索条件
      search_list: [], // 搜索数据
      search_page: 1, // 分页页码
      search_date: '', // 搜索的日期
      is_fixed_bottom: true, // 是否固定底部
      is_focus: false, // 是否输入框输入中
      is_loading: false, // 数据加载中
      all_search_loaded: false, // 全部加载完成
      list_scroll_top: 0 // 列表滚动的距离，保存上次的滚动
    }
  },
  computed: {
    ...mapGetters([
      'enterprise_id',
      'is_mobile',
      'user_info',
      'innerHeight'
    ]),
    list_height () {
      var self = this
      var val = 0
      if (self.innerHeight) {
        // 170 是搜索框的高度 10 是保留空白，防止超出
        val = self.innerHeight - 204 - 10
      }
      return val
    },
    is_show_logo () {
      // 是否显示底部搜索logo
      var self = this
      var status = true
      if (self.is_focus || self.is_loading) {
        status = false
      } else {
        if (self.search_list.length > 0 && !self.all_search_loaded) {
          status = false
        }
      }
      return status
    }
  },
  created () {
    // 初始化数据
    var _self = this
    _self.setLoading(false)
    _self.search_date = formatDay('', 'line')
  },
  activated () {
    // 页面可用
    var _self = this
    _self.$nextTick(function () {
      _self.scrollTop(_self.list_scroll_top) // 滚动到上次的距离
    })
  },
  methods: {
    ...mapActions([
      'setLoading',
      'searchLineCode'
    ]),
    inputEve (type) {
      var self = this
      if (type === 'focus') {
        self.is_focus = true
      } else if (type === 'blur') {
        self.is_focus = false
      }
    },
    // 加载更多
    loadBottom (type) {
      var self = this
      if (!self.is_mobile && !type) {
        // 在不是手机端是不进行自动触发
        return false
      }
      // 获取数据
      if (!self.all_search_loaded && !self.is_loading) {
        self.searchList(self.search_page + 1)
      }
    },
    clearText () {
      // 清空
      var _self = this
      _self.search_text = ''
    },
    switchSearchType () {
      var _self = this
      postCnzzData('1.2 点击地址搜索tab')
      // 跳转编码搜索
      _self.$router.replace({
        path: '/e/' + _self.enterprise_id + '/',
        query: {
          type: 'address'
        }
      })
    },
    linkDetail (line) {
      // 跳转详情
      var _self = this
      var path = '/lineDetail/' + line.line_id
      if ((line.sales_type + '') === '1') {
        path = '/lineDetailToBuy/' + line.line_id
      }
      _self.$router.push({
        path: '/e/' + _self.enterprise_id + path + '?is_search=1&unique_key=' + (line.unique_key || '')
      })
    },
    clickSearch () {
      reportEvent('华为首页编号查询')
      // 搜索班车按钮
      var self = this
      self.scrollTop()
      self.searchList(1)
    },
    searchList (page) {
      var _self = this
      var _page = page || 1
      var _id = ''
      if (_self.search_text) {
        _self.is_loading = true
        // 显示加载
        if (_page === 1) {
          _self.setLoading(true)
        }
        _self.searchLineCode({
          line_code: _self.search_text || '',
          page: _page,
          page_size: 15,
          date: _self.search_date || '' // 日期
        }).then(function (res) {
          if (res.data.total_page <= res.data.page) {
            _self.all_search_loaded = true
          } else {
            _self.all_search_loaded = false
          }
          _self.search_page = _page
          if (_page === 1) {
            // 加载第一页，清空
            _self.search_list = []
          }
          _self.search_list = _self.search_list.concat(res.data.list || [])
          if (_page === 1) {
            if (_self.user_info && _self.user_info.id) {
              _id = _self.user_info.id + ''
            } else {
              _id = '未登录'
            }
            if (_self.search_list.length > 0) {
              postCnzzData('13.1.1 首页编号搜索页面new', _id, '有数据')
            } else {
              postCnzzData('13.1.1 首页编号搜索页面new', _id, '无数据')
            }
          }
          _self.$nextTick(function () {
            _self.setLoading(false)
            _self.is_loading = false
            _self.checkScroll() // 检查是否滚动
            setTimeout(function () {
              if (_self.$refs.loadmore && _self.search_page > 1) {
                _self.$refs.loadmore.onBottomLoaded()
              }
            }, 500)
          })
        }, function (res) {
          showTips(res.info || '请求数据失败！')
          _self.setLoading(false)
          _self.is_loading = false
          setTimeout(function () {
            if (_self.$refs.loadmore) {
              _self.$refs.loadmore.onBottomLoaded()
            }
          }, 500)
        })
      } else {
        showTips('输入线路编号或名称！')
      }
    },
    listScroll () {
      var _self = this
      var $List = ''
      var _scrollTop = 0
      var _clientHeight = 0
      var _scrollHeight = 0
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list
        _scrollTop = $List.scrollTop || 0
        _clientHeight = $List.clientHeight || 0
        _scrollHeight = $List.scrollHeight || 0
        _self.list_scroll_top = _scrollTop // 保存上次的距离
      }
      // pc 端进行滚动，手动触发下拉更新
      if (!_self.is_mobile && _scrollHeight > 0) {
        if ((_scrollHeight - _clientHeight - _scrollTop) < 10) {
          if (!_self.all_search_loaded) {
            _self.loadBottom('trigger')
          }
        }
      }
    },
    checkScroll () {
      // 检查是否滚动，然后显示搜索logo
      var _self = this
      var $List = ''
      var _clientHeight = 0
      var _scrollHeight = 0
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list
        _clientHeight = $List.clientHeight || 0
        _scrollHeight = $List.scrollHeight || 0
      }
      if (_scrollHeight > _clientHeight) {
        _self.is_fixed_bottom = false
      } else {
        _self.is_fixed_bottom = true
      }
    },
    scrollTop (number) {
      // 重置滚动位置到顶部
      var _self = this
      var $List = ''
      if (_self.$refs.commute_list) {
        $List = _self.$refs.commute_list
        if (number && $List.scrollHeight && $List.scrollHeight > 0) {
          $List.scrollTop = number || 0
        } else {
          if ($List.scrollTop > 0) {
            $List.scrollTop = 0
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/scss/base.scss';
  .commute_code {
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    .border-bottom {
      border-bottom: solid 1px $opt-color-border;
    }
    .view-search-control {
      position: relative;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      background-color: #fff;
      .control-title {
        position: relative;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: hidden;
        border-bottom: solid 1px $opt-color-border;
        .title {
          position: relative;
          display: inline-block;
          margin: 0;
          padding: 16px 0;
          width: 50%;
          text-align: center;
          float: left;
        }
        .text {
          text-align: center;
          margin: 0;
          padding: 0;
          color: #999;
          font-size: 14px;
          line-height: 18px;
        }
        .line {
          position: absolute;
          left: 50%;
          bottom: 0;
          display: none;
          margin: 0 0 0 -55px;
          padding: 0;
          width: 110px;
          height: 3px;
          background-color: $opt-color;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
        }
        .title.active {
          .text {
            color: $opt-color;
          }
          .line {
            display: inline-block;
          }
        }
      }
      .control-search {
        position: relative;
        margin: 0;
        padding: 0;
        width: 100%;
        .address {
          position: relative;
          margin: 0 0 0 47px;
          padding: 17px 0;
          font-size: 13px;
          color: #999;
          line-height: 15px;
        }
        .address.active {
          color: #333;
        }
        .btn-change {
          z-index: 1;
          display: inline-block;
          position: absolute;
          top: 50%;
          left: 14px;
          margin: -24px 0 0 0;
          padding: 14px 4px;
          .icon {
            display: inline-block;
            margin: 0;
            padding: 0;
          }
        }
      }
      .control-input {
        position: relative;
        margin: 0;
        padding: 10px 66px 10px 46px;
        .input {
          display: block;
          width: 100%;
          position: relative;
          margin: 0;
          padding: 7px 0;
          font-size: 13px;
          color: #333;
          line-height: 15px;
          -webkit-appearance: none;
          outline: none;
          border: none;
        }
        .wrap-icon {
          display: inline-block;
          position: absolute;
          top: 50%;
          right: 24px;
          padding: 6px 16px 6px 0;
          margin: -16px 0 0 0;
          text-align: left;
        }
        .icon {
          vertical-align: top;
          display: inline-block;
          padding: 0;
          margin: 0;
        }
      }
    }
    .view-btn-control {
      position: relative;
      padding: 13px 15px;
      margin: 0;
      background-color: transparent;
      .btn-opt-common {
        position: relative;
        padding: 13px 0;
        margin: 0;
        background-color: $opt-color;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        text-align: center;
      }
    }
    .view-section {
      position: relative;
      padding: 0;
      margin: 0;
      background-color: transparent;
      .text {
        position: relative;
        padding: 0 15px 9px 15px;
        margin: 0;
        font-size: 13px;
        line-height: 18px;
        color: #999;
        text-align: left;
      }
    }
    .wrap-view-list {
      position: relative;
      padding: 0;
      margin: 0;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
      overflow: auto;
    }
    .view-list {
      position: relative;
      padding: 0 8px 0 8px;
      margin: 0;
      -webkit-overflow-scrolling: touch;
      .list-item {
        position: relative;
        padding: 0;
        margin: 0 0 10px 0;
        background-color: #fff;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
      }
      .item-top {
        position: relative;
        padding: 0 17px;
        margin: 0;
        overflow: hidden;
        background-color: #f8f8f8;
        -webkit-border-radius: 6px 6px 0 0;
        -moz-border-radius: 6px 6px 0 0;
        border-radius: 6px 6px 0 0;
        .title {
          position: relative;
          padding: 8px 0;
          margin: 0;
          max-width: 50%;
          float: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          color: #333;
          line-height: 16px;
        }
        .title-right {
          float: right;
          color: #666;
        }
      }
      .item-content {
        position: relative;
        padding: 13px 17px;
        margin: 0;
        .site {
          position: relative;
          padding: 0;
          margin: 0;
        }
        .line {
          z-index: 1;
          display: inline-block;
          position: absolute;
          top: 15px;
          left: 6px;
          padding: 0;
          margin: 0;
          width: 1px;
          height: 100%;
          background-color: #039be5;
        }
        .wrap-dot {
          z-index: 2;
          position: absolute;
          top: 0;
          left: 1px;
          padding: 4px 0;
          margin: 0 0 0 0;
          background-color: #fff;
          overflow: hidden;
          .dot {
            float: left;
            position: relative;
            vertical-align: top;
            display: inline-block;
            padding: 0;
            margin: 0 0 0 0;
            width: 7px;
            height: 7px;
            background-color: #039be5;
            -webkit-border-radius: 6px;
            -moz-border-radius: 6px;
            border-radius: 6px;
          }
        }
        .content-text {
          position: relative;
          padding: 0 160px 13px 22px;
          margin: 0;
          font-size: 12px;
          color: #333;
          text-align: left;
          line-height: 16px;
        }
        .site.end {
          .content-text {
            padding-bottom: 0;
          }
          .dot {
            background-color: #ff6a2e;
          }
        }
        .content-right {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          margin: 0;
          text-align: right;
          max-width: 160px;
          white-space: normal;
          .text {
            vertical-align: top;
            display: inline-block;
            font-size: 12px;
            color: #333;
            line-height: 16px;
          }
          span {
            vertical-align: top;
            display: inline-block;
          }
        }
        .content-label {
          overflow: hidden;
          span {
            float: right;
          }
        }
      }
      .item-bottom {
        position: relative;
        margin: 0;
        padding: 8px 17px;
        -webkit-border-radius: 0 0 6px 6px;
        -moz-border-radius: 0 0 6px 6px;
        border-radius: 0 0 6px 6px;
        border-top: solid 1px #dddddd;
        .text {
          word-break: break-all;
          line-height: 16px;
          font-size: 12px;
          color: #333;
        }
      }
    }
    .view-tips {
      position: relative;
      margin: 0;
      padding: 0;
      .wrap-icon {
        position: relative;
        padding: 25px 0 20px 0;
        text-align: center;
        .icon {
          position: relative;
          display: inline-block;
          vertical-align: top;
        }
      }
      .text {
        position: relative;
        display: block;
        text-align: center;
        font-size: 13px;
        color: #999;
      }
    }
    .view-tips.add-padding-bottom {
      padding-bottom: 30px;
    }
    .view-search-logo {
      position: relative;
      display: block;
      text-align: center;
      margin: 0;
      padding: 10px 0 0 0;
      overflow: hidden;
      width: 100%;
      max-width: 100%;
      .icon {
        width: 180px;
        height: auto;
        display: inline-block;
        vertical-align: top;
        padding: 0;
        margin: 0;
      }
    }
    .view-search-logo.view-fixed {
      position: fixed;
      bottom: 10px;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// CommuteCode.vue?04fd7f27